/* shto-testimonials-chips: the blue bar under the review cards follows the row as it is swiped (assets/shto-swipe.js moves
   the row). No row to swipe (desktop, or few cards): no bar. */
(function () {
  function init(slider) {
    if (slider.shtoChips) return;
    slider.shtoChips = true;
    var track = slider.querySelector('[data-shto-chips-track]');
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (max < 1) { slider.setAttribute('data-shto-chips-static', ''); return; }
      slider.removeAttribute('data-shto-chips-static');
      slider.style.setProperty('--shto-progress', Math.min(1, Math.max(0, track.scrollLeft / max)).toFixed(4));
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }
  function all() { document.querySelectorAll('[data-shto-testimonials-chips]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
